var map = {
	"./academic.js": "1f03",
	"./banner.js": "6fb8",
	"./cmsStatus.js": "b6b9",
	"./da_detail.js": "40d7",
	"./da_menu.js": "bcc3",
	"./da_spiritWork.js": "362e",
	"./detail.js": "b7e1",
	"./document.js": "611d",
	"./dq_MOST.js": "477d",
	"./dq_carousel.js": "a001",
	"./dq_detail.js": "f800",
	"./dq_dynamic.js": "7ee7",
	"./dq_learn.js": "0ddb",
	"./dq_menu.js": "ae17",
	"./dq_special.js": "ccae",
	"./dq_wonderful.js": "1d28",
	"./dq_work.js": "e5ef",
	"./dq_youth.js": "5132",
	"./ds_carousel.js": "fe6a",
	"./ds_dangweiwork.js": "0dd3",
	"./ds_dataCenter.js": "d57b",
	"./ds_detail.js": "018c",
	"./ds_dynamic.js": "6623",
	"./ds_menu.js": "62ca",
	"./ds_spiritWork.js": "569a",
	"./ds_youth.js": "94bb6",
	"./en_banner.js": "756b",
	"./en_content.js": "d7d0",
	"./en_detail.js": "8856",
	"./en_menu.js": "56d2",
	"./en_news.js": "cd56",
	"./footer.js": "23e7b",
	"./links.js": "6496",
	"./menu.js": "1307",
	"./news.js": "611b",
	"./oneStop.js": "7e8f",
	"./periodical.js": "3ad1",
	"./science.js": "ced9",
	"./search.js": "2219",
	"./thinkTank.js": "90be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c653";